import { memo } from 'react';

import { Button } from '@air/primitive-button';

export type WorkspaceAgentGuidedVariantSettingsActionsProps = {
  generateLabel: string;
  isGenerateDisabled: boolean;
  onGenerate: () => void;
};

export const WorkspaceAgentGuidedVariantSettingsActions = memo(
  ({ generateLabel, isGenerateDisabled, onGenerate }: WorkspaceAgentGuidedVariantSettingsActionsProps) => (
    <div className="flex items-center justify-end gap-2">
      <Button
        appearance="filled"
        color="blue"
        data-testid="WORKSPACE_AGENT_GUIDED_VARIANT_GENERATE"
        disabled={isGenerateDisabled}
        onClick={onGenerate}
        size="small"
      >
        {generateLabel}
      </Button>
    </div>
  ),
);

WorkspaceAgentGuidedVariantSettingsActions.displayName = 'WorkspaceAgentGuidedVariantSettingsActions';
